import { VStack } from "@gluestack-ui/themed";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { InputTypeSelectControlled } from "@repo/core/components/forms/InputTypeSelect";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";
import { Text } from "@repo/core/components/core/Text";
import { InvoiceDataFormController } from "./controller";

const InvoiceDataForm = () => {
  const {
    control,
    expirationDateOptions,
    invoiceDeliveryOptions,
    isLoadingInvoiceDeliveryOptions,
    isEmailDelivery,
    handleOnSubmitForm,
    handleGoBack,
    handleClose
  } = InvoiceDataFormController();
  return (
    <PageScaffold
      onBackPress={handleGoBack}
      showBackButtonOnWeb
      onPressRightIcon={handleClose}
      rightWebLabel="Fechar"
      title="Proposta de Crédito"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
        />
      }
    >
      <VStack w="$full" gap="$4" pb="$4">
        <ProgressBar progress={80} />
        <VStack gap="$6">
          <InputControlled
            control={control}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect={false}
            importantForAutofill="no"
            isRequired={isEmailDelivery}
            label="E-mail"
            name="email"
            placeholder="Digite o seu e-mail"
            textContentType="none"
          />
          <InputControlled
            control={control}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect={false}
            importantForAutofill="no"
            isRequired={isEmailDelivery}
            label="Confirmar E-mail"
            name="confirmEmail"
            placeholder="Digite o seu e-mail"
            textContentType="none"
          />
        </VStack>
        <Text>Escolha o melhor dia do mês para o vencimento da fatura:</Text>
        <InputTypeSelectControlled
          control={control}
          name="invoiceDate"
          inputTypes={expirationDateOptions ?? []}
          isRequired
          isFullWidth
        />
        <Text>Como deseja receber a fatura?</Text>
        <SelectControlled
          control={control}
          name="invoiceDelivery"
          options={invoiceDeliveryOptions}
          isRequired
          label="Canal de envio"
          placeholder={
            isLoadingInvoiceDeliveryOptions
              ? "Carregando canais"
              : "Selecione o canal"
          }
          isLoading={isLoadingInvoiceDeliveryOptions}
        />
      </VStack>
    </PageScaffold>
  );
};

export default InvoiceDataForm;
